<template>
  <SearchPage />
</template>

<script>
  import SearchPage from '../components/SearchPage'

  export default {
    components: {
      SearchPage
    }
  }
</script>
